import { Component, OnInit } from '@angular/core';
import { IUser } from 'src/app/models';
import { UserService, AlertService } from 'src/app/services';
import { BlockUIHandlerService } from 'src/app/common/services.index';
import { ALERTS } from 'src/app/common/enums';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  //VARBOX
  isPasswordInputReandOnly: boolean;
  modalReference: NgbModalRef;
  users: IUser[];
  user: IUser;
  userForm: FormGroup;
  constructor(private userService: UserService
    ,private alertService: AlertService
    ,private blockUiService: BlockUIHandlerService
    ,private formBuilder: FormBuilder
    ,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.InitVariables();
  }

  InitVariables(): void {
    let u = {} as IUser;
    this.isPasswordInputReandOnly = true;
    this.ResetUserForm();
    this.LoadData();
  }

  LoadData(): void {
    this.Get();
  }

  Store(): void {
    const USER = this.userForm.value as IUser;
    USER.Id === -1 ? this.CreateUser(USER): this.UpdateUser(USER);
  }

  RaiseUserModal(content, isUpdating: boolean = false): void {
    if (!isUpdating) {
      this.ResetUserForm();
      this.isPasswordInputReandOnly = true;
      this.userForm.patchValue({
        UpdatePassword: true
      });
    }
    else {
      this.isPasswordInputReandOnly = false;
      this.userForm.patchValue({
        UpdatePassword: false
      });
      console.log(this.userForm);
    }
    
    this.modalReference = this.modalService.open(content, 
      {
        centered: true,
        backdrop: 'static'
      });
  }

  CloseModal(): void {
    this.modalReference.close();
  }

  ResetUserForm(): void {
    this.userForm = this.formBuilder.group({
      Id: [-1],
      Email: ['', Validators.required],
      Password: [''],
      UserName: ['', Validators.required],
      Active: [false, Validators.required],
      UpdatePassword: [false]
    });
  }

  Get(): void {
    this.blockUiService.Start(1, `Procesando, espere por favor`);
    this.userService.Get().pipe(finalize(() => this.blockUiService.Stop())).subscribe(next => {
      if (next.Result) {
        this.users = next.Data;
        this.alertService.ShowSmallCornerAlert(`Usuarios obtenidos`, ALERTS.success);
      }
      else {
        this.alertService.ShowSmallCornerAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.warning);
      }
    }, error => {
      console.log(error);
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.warning);
    });
  }

  GetUser(_id: number, content: any): void {
    this.blockUiService.Start(1, `Procesando, espere por favor`);
    this.userService.GetUser(_id).pipe(finalize(() => this.blockUiService.Stop())).subscribe(next => {
      if (next.Result) {
        this.user = next.Data;
        this.user.Password = '';
        this.userForm.patchValue({
          ...this.user
        });
        this.RaiseUserModal(content, true);
      }
      else {
        this.alertService.ShowSmallCornerAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.warning);
      }
    }, error => {
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.warning);
    });
  }

  CreateUser(_user: IUser): void {
    let MOBJECT = { ...this.userForm.value };
    
    if (!MOBJECT.UpdatePassword) {
      this.alertService.ShowSmallCornerAlert(`El check de editar contraseña debe de estar seleccionado`, ALERTS.info);
      return;
    }
    if (_user.Password.length < 8) {
      this.alertService.ShowSmallCornerAlert(`La contraseña debe tener al menos 8 caracteres`, ALERTS.info);
      return;
    }
    this.blockUiService.Start(1, `Creando usuario`);
    this.userService.Store(_user).subscribe(next => {
      this.blockUiService.Stop();
      if (next.Result) {
        this.CloseModal();
        this.alertService.ShowSmallCornerAlert(`Usuario creado`, ALERTS.success);
        this.Get();
      }
      else {
        this.alertService.ShowBigCenteredAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.error);
        console.log(next);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowBigCenteredAlert(`Error: ${error}`, ALERTS.error);
    });
  }

  UpdateUser(_user: IUser): void {
    
    let MOBJECT = { ...this.userForm.value };
    
    if (!MOBJECT.UpdatePassword) {
      _user.Password = null;
    }
    else {
      if (_user.Password.length < 8) {
        this.alertService.ShowSmallCornerAlert(`La contraseña debe tener al menos 8 caracteres`, ALERTS.info);
        return;
      }
    }
    
    this.blockUiService.Start(1, `Actualizando usuario`);
    this.userService.Update(_user).subscribe(next => {
      this.blockUiService.Stop();
      if (next.Result) {
        this.CloseModal();
        this.alertService.ShowSmallCornerAlert(`Usuario actualizado`, ALERTS.success);
        this.Get();
      }
      else {
        this.alertService.ShowBigCenteredAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.error);
        console.log(next);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowBigCenteredAlert(`Error: ${error}`, ALERTS.error);
    });
  }

  ToggleInputPasswordType(): void {
    this.isPasswordInputReandOnly = !this.isPasswordInputReandOnly
  }
}